export const SPRITES = {
  "baliBeach": {
    srcs: "assets/locations/baliBeach.png",
    width: 1216,
    height: 960
  },
  "baliCafe": {
    srcs: "assets/locations/baliCafe.png",
    width: 1216,
    height: 960
  },
  "baliVilla": {
    srcs: "assets/locations/baliVilla.png",
    width: 1216,
    height: 960
  },
  "cityStreet": {
    srcs: "assets/locations/cityStreet.png",
    width: 1216,
    height: 960
  },
  "hotelRoom": {
    srcs: "assets/locations/hotelRoom.png",
    width: 1216,
    height: 960
  },
  "riverbank": {
    srcs: "assets/locations/riverbank.png",
    width: 1216,
    height: 960
  },
  "baliOffice": {
    srcs: "assets/locations/baliOffice.png",
    width: 1216,
    height: 960
  },
  "baliHill": {
    srcs: "assets/locations/baliHill.png",
    width: 1216,
    height: 960
  },
  "baliBar": {
    srcs: "assets/locations/baliBar.png",
    width: 1216,
    height: 960
  },
  "newCafe": {
    srcs: "assets/locations/newCafe.png",
    width: 1216,
    height: 960
  },
  "airplane": {
    srcs: "assets/locations/airplane.png",
    width: 1216,
    height: 960
  },
  "ericsApartment": {
    srcs: "assets/locations/ericsApartment.png",
    width: 1216,
    height: 960
  },
  "ericsApartmentOutside": {
    srcs: "assets/locations/ericsApartmentOutside.png",
    width: 1216,
    height: 960
  },
  "reina": {
    srcs: "assets/characters/reina-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "eric": {
    srcs: "assets/characters/eric-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "mia": {
    srcs: "assets/characters/mia-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "james": {
    srcs: "assets/characters/james-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "barista": {
    srcs: "assets/characters/barista-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "teammate": {
    srcs: "assets/characters/teammate-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "woman": {
    srcs: "assets/characters/woman-{variation}.png",
    variations: ['neutral', 'happy', 'sad', 'embarrassed', 'crying', 'surprised', 'angry', 'thinking'],
    width: 416,
    height: 624
  },
  "homePageBackground": {
    srcs: "assets/pages/homePageBackground.png",
    width: 1216,
    height: 960
  },
  "nightOverlay": {
    srcs: "assets/effects/nightOverlay.png",
    width: 1216,
    height: 960
  }
};

export const SOUNDS = {}
